<a *ngIf="getLinkUrl()" [href]="getLinkUrl()">{{linkText}}<img *ngIf="iconImage" src="assets/{{iconImage}}" /></a>
